import { createAsyncThunk } from '@reduxjs/toolkit';

import * as api from 'api/methods';

import * as types from './types';

export const getLessonCategories = createAsyncThunk<any, any>(
  types.GET_LESSON_CATEGORIES,
  async (params: Record<string, any>) => {
    const categories = await api.getLessonCategories(params);

    return categories;
  },
);

export const updateLessonCategoryById = createAsyncThunk<any, any>(
  types.UPDATE_LESSON_CATEGORY_BY_ID,
  async ({ categoryId, data }: { categoryId: string; data: any }) => {
    const category = await api.updateLessonCategoryById({ categoryId, data });

    return { updatedCategory: category };
  },
);

export const removeLessonCategoryById = createAsyncThunk<any, any>(
  types.REMOVE_LESSON_CATEGORY_BY_ID,
  async (categoryId: string) => {
    await api.removeLessonCategoryById(categoryId);

    return categoryId;
  },
);
